/**
 * Add functionality to an input field to restrict to numeric values only
 * Updates the model with the enter amount in cents (long value).
 *
 * usage <input mc-number type="input" ng-model="amount" />
 *
 *  or you can optionally pass in the number of decimal places
 * usage <input mc-number='2' type="input" ng-model="amount" />
 *
 * adding mc-use-thousand-separator="true" will add the localised thousand group separator to the view value
 *
 * adding mc-use-all-decimal-places="true" will force the view value to display all decimal places,
 * e.g. with this option enabled 2.1 will display as 2.100 if the number of decimal places is set to 3
 *
 * adding min="10" will cause the validation to fail if the value is less than 10
 * adding max="10" will cause the validation to fail if the value is greater than 10
 *
 * adding mc-prepend-symbol="%" will add a '%' to the start of the number's view value, e.g.: %25
 * adding mc-append-symbol="%" will add a '%' to the start of the number's view value, e.g.: 25%
 */

angular.module('qkr').directive('mcNumber', ['utils', '$locale', function(utils, $locale) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function postLink(scope, element, attrs, ngModel) {
            const decimalPlaces = (attrs.mcNumber) ? attrs.mcNumber * 1 : 0;
            const decimalSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
            const thousandSeparator = $locale.NUMBER_FORMATS.GROUP_SEP;
            const useThousandSeparator = (attrs.mcUseThousandSeparator === 'true');
            const useAllDecimalPlaces = (attrs.mcUseAllDecimalPlaces === 'true');
            const minValue = (attrs.min) ? attrs.min * 1 : null;
            const maxValue = (attrs.max) ? attrs.max * 1 : null;
            const prependSymbol = attrs.mcPrependSymbol != null ? '' + attrs.mcPrependSymbol : null;
            const appendSymbol = attrs.mcAppendSymbol != null ? '' + attrs.mcAppendSymbol : null;

            ngModel.$validators.max = function(value) {
                if (maxValue != null && (value === null || value === '' || value > maxValue)) {
                    return false;
                }

                return true;
            };

            ngModel.$validators.min = function(value) {
                if (minValue != null && (value === null || value === '' || value < minValue)) {
                    return false;
                }

                return true;
            };

            // Format the model value into the view value on change
            ngModel.$formatters.unshift((modelValue) => {
                if (modelValue === null || modelValue === '') {
                    return null;
                }

                const localisedValue = getLocalisedValue(modelValue, decimalPlaces, useAllDecimalPlaces, decimalSeparator, useThousandSeparator ? thousandSeparator : '', prependSymbol, appendSymbol);
                return localisedValue;
            });

            // Parse the view value into the model value on change
            ngModel.$parsers.push((viewValue) => {
                if (viewValue === undefined || viewValue === null || viewValue === '') {
                    return null;
                }

            	const amount = accounting.unformat(viewValue, decimalSeparator);
                return amount;
            });

            // Then the user enters the input select whatever value is there
            element.bind('click ', () => {
                element.select();
            });

            element.bind('focus ', () => {
                // Set view value without thousand separator
                if (!element.attr('readOnly')) {
                    scope.$apply(() => {
                        if (ngModel.$viewValue === null || ngModel.$viewValue === '') {
                            return;
                        }

                        const num = getUnlocalisedValue(ngModel.$viewValue, decimalSeparator);
                        const localisedValue = getLocalisedValue(num, decimalPlaces, useAllDecimalPlaces, decimalSeparator, '', null, null);
                        ngModel.$setViewValue(localisedValue);
                        ngModel.$render();
                    });
                }
            });

            // Listen on the input blur event and update the model view value if it changes
            element.bind('blur ', () => {
                scope.$apply(() => {
                    if (ngModel.$viewValue === null || ngModel.$viewValue === '') {
                        return;
                    }

                    const num = getUnlocalisedValue(ngModel.$viewValue, decimalSeparator);
                    const localisedValue = getLocalisedValue(num, decimalPlaces, useAllDecimalPlaces, decimalSeparator, useThousandSeparator ? thousandSeparator : '', prependSymbol, appendSymbol);
                    ngModel.$setViewValue(localisedValue);
                    ngModel.$render();
                });
            });

            // Restrict to numeric input on keypress
            element.bind('keypress ', (event) => {
                const num = String.fromCharCode(event.which);

                // Cancel the keypress if the numeric rules are not met
                if (restrictNumericKey(event, decimalSeparator)) {
                    event.preventDefault();
                    return;
                }

                // Cancel the keypress if the decimal separator is already present
                if (isDecimalSeparatorAlreadyPresent(event, element.val(), decimalSeparator)) {
                    event.preventDefault();
                    return;
                }

                // If a decimal number check for number type (inc. decimal point) , and when it's not
                if (decimalPlaces === 0 && !utils.isNumeric(num) && (event.which === 46 && event.keyCode !== 9 && event.keyCode !== 8 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40)) {
                    event.preventDefault();
                    return;
                } else if (!utils.isNumber(num) && ((event.charCode === 0 && event.keyCode !== 46) && event.keyCode !== 9 && event.keyCode !== 8 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40 && event.keyCode !== 12)) {
                    event.preventDefault();
                    return;
                }
            });

            // Restrict keys that are not are not used for entering numeric values
            function restrictNumericKey(e, decimalSeparator) {
                // Command key
                if (e.metaKey) {
                    return true;
                }
                // Alphabets
                if ((e.which >= 65 && e.which <= 125)) {
                    return true;
                }
                // Special characters
                if (e.which === 0) {
                    // Tab , backspace, arrow keys, delete
                    if (e.keyCode === 46 || e.keyCode === 9 || e.keyCode === 8 || e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40) {
                        return false;
                    } else {
                        return true;
                    }
                }

                // Special chars
                if ((e.which >= 32 && e.which <= 46 && String.fromCharCode(e.which) !== decimalSeparator) || (e.which === 45) || (e.which === 47) || (e.which >= 58 && e.which <= 64) || (e.which >= 91 && e.which <= 96) || (e.which >= 123 && e.which <= 126)) {
                    return true;
                }
            }

            function isDecimalSeparatorAlreadyPresent(e, value, decimalSeparator) {
                if (String.fromCharCode(e.which) === decimalSeparator && value.indexOf(decimalSeparator) !== -1) {
                    return true;
                }
                return false;
            }

            function getLocalisedValue(value, decimalPlaces, useAllDecimalPlaces, decimalSeparator, thousandsSeparator, prependSymbol, appendSymbol) {
                let decimalPlacesToUse;

                if (useAllDecimalPlaces) {
                    decimalPlacesToUse = decimalPlaces;
                } else {
                    decimalPlacesToUse = getMaxRequiredDecimalPlaces(value);
                }

                let cleanLocalisedValue = accounting.formatNumber(value, decimalPlacesToUse, thousandsSeparator, decimalSeparator);
                if (prependSymbol !== null) {
                    cleanLocalisedValue = prependSymbol + cleanLocalisedValue;
                }
                if (appendSymbol !== null) {
                    cleanLocalisedValue = cleanLocalisedValue + appendSymbol;
                }

                return cleanLocalisedValue;
            }

            function getMaxRequiredDecimalPlaces(value) {
                const unformattedNumber = accounting.unformat(value);

                if (utils.isDecimal(unformattedNumber)) {
                    const unformattedNumberStr = unformattedNumber + '';
                    const remainder = (unformattedNumberStr).substr(unformattedNumberStr.lastIndexOf('.') + 1, unformattedNumberStr.length);
                    return remainder.length;
                } else {
                    return 0;
                }
            }

            function getUnlocalisedValue(localisedValue, decimalSeparator) {
                let num = accounting.unformat(localisedValue, decimalSeparator);

                if (utils.isDecimal(num)) {
                    num = accounting.toFixed(num, decimalPlaces);
                }

                return num;
            }
         }
    };
}]);



// WEBPACK FOOTER //
// ./src/directives/number.js